/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function DropletSmall(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'DropletSmall',
      'aria-hidden': true,
      focusable: false,
      width:  9 * scale,
      height: 14 * scale,
      viewBox: '0 0 9 14',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M1 9.532C1 11.447 2.563 13 4.49 13c1.926 0 3.492-1.553 3.492-3.468 0-.024-.004-.046-.004-.068s.004-.044.004-.065c0-.36-.09-.747-.09-.747-.495-2.002-3.41-7.634-3.41-7.634S1.93 6.04 1.145 8.402A3.5 3.5 0 0 0 1 9.398c0 .016.005.03.005.044a1 1 0 0 0-.005.09"}))
}
